import { ArrowOutwardRounded } from '@mui/icons-material';
import { Box, Chip, Typography } from '@mui/material';
import { replace } from 'lodash';
import numeral from 'numeral';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalComponent from 'src/components/Modal/ModalComponent';
import CustomTable from 'src/components/Table';
import { useQueryUserInfo } from 'src/services/queries';
import { useQueryGetHistoryBulkUpload } from 'src/services/queries/useQueryAILabeling';
import { EmptyText, FORMAT_DATE_TIME, LIMIT_GET_LIST } from 'src/utils/constants/config';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { formatUTCTime } from 'src/utils/helpers/dayjs';
import { useBulkUploadSearchStore } from 'src/zustand/useAILabelingStore';

const FileUploadHistoryView = ({ handleClose, open }: { open: boolean; handleClose: VoidFunction }) => {
  const { data: userInfo } = useQueryUserInfo();
  const { dispatch } = useBulkUploadSearchStore();
  const [params, setParams] = useState({
    offset: 0,
    limit: LIMIT_GET_LIST,
  });
  const {
    data: { data, total_records },
    isFetching,
  } = useQueryGetHistoryBulkUpload({
    user_uuid: userInfo.data.uuid,
    ...params,
  });

  const configColumn = [
    {
      id: 'file_name',
      disableSort: true,
      label: 'File Name',
      cell: (data: TypeBulkUploadResultHistory) => (
        <Typography sx={{ wordWrap: 'break-word' }} color={'text.secondary'} variant="body2">
          {data.org_file_name}
        </Typography>
      ),
    },
    {
      id: 'capacity',
      disableSort: true,
      label: 'Capacity (KB)',
      cell: (data: TypeBulkUploadResultHistory) => (
        <Typography color={'text.secondary'} variant="body2">
          {numeral(data.capacity).format('0.0 b')}
        </Typography>
      ),
    },
    {
      id: 'status',
      disableSort: true,
      label: 'Status',
      cell: (data: TypeBulkUploadResultHistory) => {
        const color = data.file_status === 'Processed' ? 'success' : 'info';
        return <Chip color={color} size="small" label={data.file_status} />;
      },
    },
    {
      id: 'date_time',
      disableSort: true,
      label: 'Date & Time',
      width: 180,
      cell: (data: TypeBulkUploadResultHistory) => (
        <Typography noWrap color={'text.secondary'} variant="body2">
          {formatUTCTime(FORMAT_DATE_TIME.DD_MM_YYYY_HH_MM_A, data.time_received, FORMAT_DATE_TIME.UTC_YEAR_FIRST)}
        </Typography>
      ),
    },
    {
      id: 'type',
      disableSort: true,
      label: 'Type',
      cell: (data: TypeBulkUploadResultHistory) => (
        <Typography color={'text.secondary'} variant="body2">
          {data.file_type}
        </Typography>
      ),
    },
    {
      id: 'view_result',
      disableSort: true,
      label: 'View Result',
      cell: (data: TypeBulkUploadResultHistory) => {
        if (data.file_status !== 'Processed') return EmptyText;

        return (
          <Link
            onClick={() => dispatch(false, 'visibleHistoryBulkUpload')}
            to={{
              pathname: replace(AuthRouteKeys.AIHSCodeBulkResult, ':id', data.file_id ?? ''),
            }}
          >
            <ArrowOutwardRounded color="secondary" />
          </Link>
        );
      },
    },
  ] as ConfigCell<TypeBulkUploadResultHistory>[];
  return (
    <ModalComponent handleClose={handleClose} open={open}>
      <Box>
        <Typography variant="h5" mb={3}>
          File Upload History
        </Typography>

        <CustomTable
          tableMaxHeight={10000}
          configColumn={configColumn}
          dataKey={'file_id'}
          onChangePage={(e) => setParams({ ...params, ...{ offset: e } })}
          onChangePageSize={(e) => setParams({ ...params, ...{ offset: 0, limit: e } })}
          page={params.offset}
          pageSize={params.limit}
          totalRecords={total_records}
          loading={isFetching}
          isHover={false}
          data={getArrayDefault(data)}
        />
      </Box>
    </ModalComponent>
  );
};

export default FileUploadHistoryView;
